import React from 'react'
import { ColumnRank, ColumnBib, ColumnName, ColumnNoc } from "components/common/TableColumns"
import { ColumnIntermediateAvgSpeed } from "components/common/TableColumnsIntermediates"
import { createColumnsIntermediate } from 'components/sports/crd/helper/CrdHelpers'



export function TableColumns(columnsAdded) {
    let columnsExt = createColumnsIntermediate(columnsAdded);
    return (
        [
            ColumnRank({}),
            ColumnBib({ label: "HeaderRaceNo" }),
            ColumnNoc({}),
            ColumnName({}),
            ...columnsExt,
            ColumnIntermediateAvgSpeed({}),
        ]
    )
}



export function TableColumnsSM(columnsAdded) {
    let columnsExt = createColumnsIntermediate(columnsAdded);
    return (
        [
            ColumnRank({}),
            ColumnBib({ label: "HeaderRaceNo" }),
            ColumnNoc({}),
            ColumnName({}),
            ...columnsExt,
        ]
    )
}
